/* Gond Siyah landing interactions. Section 01 requires no JavaScript. Future sliders/videos go here. */




/* SECTION 05: Customer Reviews — append to existing gs-landing.js */
(function(){
 function initReviews(root){
  root.querySelectorAll('[data-gs-reviews-carousel]').forEach(function(carousel){
   if(carousel.dataset.gsReady==='true')return;
   carousel.dataset.gsReady='true';
   var track=carousel.querySelector('.gs-reviews__track'),cards=Array.from(track.children),dots=carousel.querySelector('[data-gs-reviews-dots]'),viewport=carousel.querySelector('.gs-reviews__viewport');
   var prev=carousel.querySelector('[data-gs-reviews-prev]'),next=carousel.querySelector('[data-gs-reviews-next]'),index=0;
   function visible() {
  if (window.matchMedia('(max-width: 575px)').matches) {
    return 1;
  }

  if (window.matchMedia('(max-width: 749px)').matches) {
    return 2;
  }

  return 3;
}
   function maxIndex(){return Math.max(0,cards.length-visible());}
   function render(){
    index=Math.min(Math.max(index,0),maxIndex());
    var offset=cards[index]?cards[index].offsetLeft-cards[0].offsetLeft:0;
    track.style.transform='translate3d('+(-offset)+'px,0,0)';
    dots.replaceChildren();
    for(var i=0;i<=maxIndex();i++)(function(n){var b=document.createElement('button');b.type='button';b.className='gs-reviews__dot';b.setAttribute('aria-label','Show reviews starting at '+(n+1));b.setAttribute('aria-current',String(n===index));b.addEventListener('click',function(){index=n;render()});dots.appendChild(b)})(i);
    prev.disabled=next.disabled=cards.length<=visible();
   }
   prev.addEventListener('click',function(){index=index<=0?maxIndex():index-1;render()});
   next.addEventListener('click',function(){index=index>=maxIndex()?0:index+1;render()});
   viewport.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();next.click()}if(e.key==='ArrowLeft'){e.preventDefault();prev.click()}});
   var startX=null;viewport.addEventListener('touchstart',function(e){startX=e.touches[0].clientX},{passive:true});viewport.addEventListener('touchend',function(e){if(startX===null)return;var delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)>45)(delta<0?next:prev).click();startX=null},{passive:true});
   var resizeTimer;window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(render,100)});
   render();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initReviews(document)});else initReviews(document);
 document.addEventListener('shopify:section:load',function(e){initReviews(e.target)});
})();









/* SECTION 09: append to gs-landing.js */
(function(){
  function setup(root){
    if(root.dataset.videoReady==='1')return;root.dataset.videoReady='1';
    const viewport=root.querySelector('[data-video-viewport]'),items=Array.from(root.querySelectorAll('.gs-videos__item')),dots=root.querySelector('[data-video-dots]');
    if(!viewport||!items.length)return;
    const section=root.closest('.gs-videos'),modal=section.querySelector('[data-video-modal]'),frame=section.querySelector('[data-video-frame]');
    let lastFocus=null;
    function visible(){return Math.max(1,Math.round(viewport.clientWidth/(items[0].getBoundingClientRect().width+parseFloat(getComputedStyle(root.querySelector('.gs-videos__track')).gap||0))))}
    function maxIndex(){return Math.max(0,items.length-visible())}
    function current(){let x=viewport.scrollLeft;let index=0;items.forEach((item,i)=>{if(item.offsetLeft-items[0].offsetLeft<=x+3)index=i});return Math.min(index,maxIndex())}
    function go(index){const bounded=Math.max(0,Math.min(index,maxIndex()));viewport.scrollTo({left:items[bounded].offsetLeft-items[0].offsetLeft,behavior:'smooth'});update(bounded)}
    function update(index){const count=maxIndex()+1;dots.innerHTML='';for(let i=0;i<count;i++){const b=document.createElement('button');b.type='button';b.className='gs-videos__dot';b.setAttribute('aria-label','Show video '+(i+1));if(i===index)b.setAttribute('aria-current','true');b.addEventListener('click',()=>go(i));dots.appendChild(b)}}
    root.querySelector('[data-video-prev]').addEventListener('click',()=>go(current()<=0?maxIndex():current()-1));
    root.querySelector('[data-video-next]').addEventListener('click',()=>go(current()>=maxIndex()?0:current()+1));
    let raf=0;viewport.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>update(current()))},{passive:true});window.addEventListener('resize',()=>update(current()));update(0);
    function close(){frame.replaceChildren();modal.hidden=true;document.body.style.removeProperty('overflow');if(lastFocus)lastFocus.focus()}
    section.querySelectorAll('[data-video-close]').forEach(b=>b.addEventListener('click',close));
    root.querySelectorAll('[data-video-play]').forEach(b=>b.addEventListener('click',()=>{const id=b.dataset.videoId;if(!/^[A-Za-z0-9_-]{11}$/.test(id||''))return;lastFocus=b;const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0';iframe.title='YouTube customer story';iframe.allow='accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share';iframe.allowFullscreen=true;frame.replaceChildren(iframe);modal.hidden=false;document.body.style.overflow='hidden';section.querySelector('.gs-videos__close').focus()}));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close()});
  }
  function init(scope){(scope||document).querySelectorAll('[data-gs-video-stories]').forEach(setup)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();









/* SECTION 10 — Buy Now + Google Sheet Lead Form */
(function () {
  function init(root) {
    root.querySelectorAll('.gs-final').forEach(function (section) {
      if (section.dataset.gsFinalReady === '1') return;
      section.dataset.gsFinalReady = '1';

      /* BUY NOW — existing Shopify checkout */
      var buy = section.querySelector('[data-gs-final-buy]');
      var buyStatus = section.querySelector('[data-gs-buy-status]');

      if (buy) {
        buy.addEventListener('click', async function () {
          var id = Number(buy.dataset.variantId);
          if (!id) return;

          buy.disabled = true;
          if (buyStatus) {
            buyStatus.textContent = 'Opening checkout…';
          }

          try {
            var rootPath =
              window.Shopify && Shopify.routes
                ? Shopify.routes.root
                : '/';

            var response = await fetch(rootPath + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: id, quantity: 1 }]
              })
            });

            if (!response.ok) {
              throw new Error('Unable to add product');
            }

            window.location.href = '/checkout';

          } catch (error) {
            if (buyStatus) {
              buyStatus.textContent =
                'Could not open checkout. Please try again.';
            }
            buy.disabled = false;
          }
        });
      }

      /* LEAD FORM */
      var form = section.querySelector('[data-gs-final-form]');
      if (!form) return;

      var status = section.querySelector('[data-gs-form-status]');
      var submit = form.querySelector('[type="submit"]');
      var submitting = false;

      var THANK_YOU_URL = '/pages/thank-you-info';

      function checkSaved(endpoint, nonce, timeout) {
        return new Promise(function (resolve) {
          var callback =
            'gsLeadCb_' +
            Date.now() + '_' +
            Math.random().toString(36).slice(2);

          var script = document.createElement('script');
          var finished = false;
          var timer;

          function finish(saved) {
            if (finished) return;
            finished = true;

            clearTimeout(timer);
            script.remove();

            try {
              delete window[callback];
            } catch (error) {
              window[callback] = undefined;
            }

            resolve(saved);
          }

          window[callback] = function (data) {
            finish(Boolean(data && data.saved));
          };

          script.onerror = function () {
            finish(false);
          };

          timer = setTimeout(function () {
            finish(false);
          }, timeout);

          script.src =
            endpoint +
            (endpoint.includes('?') ? '&' : '?') +
            'nonce=' + encodeURIComponent(nonce) +
            '&callback=' + encodeURIComponent(callback);

          document.head.appendChild(script);
        });
      }

      function wait(milliseconds) {
        return new Promise(function (resolve) {
          setTimeout(resolve, milliseconds);
        });
      }

      async function confirmSaved(endpoint, nonce) {
        /*
          Start checking shortly after POST begins.
          Keep polling until the lead is confirmed.
          Do not redirect without confirmation.
        */
        var checks = [1200, 1800, 2500, 3500];

        for (var i = 0; i < checks.length; i++) {
          var saved = await checkSaved(
            endpoint,
            nonce,
            checks[i]
          );

          if (saved) return true;

          if (i < checks.length - 1) {
            await wait(250);
          }
        }

        return false;
      }

      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        if (submitting) return;
        if (!form.reportValidity()) return;

        var endpoint = (form.dataset.endpoint || '').trim();

        if (
          !/^https:\/\/script\.google\.com\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(endpoint)
        ) {
          status.textContent = 'Form endpoint is not configured.';
          return;
        }

        var phone = form.elements.phone.value.replace(/\D/g, '');

        if (phone.length !== 10) {
          status.textContent =
            'Enter a valid 10-digit phone number.';
          return;
        }

        if (form.elements.website.value) return;

        submitting = true;
        submit.disabled = true;
        status.textContent = 'Submitting your details…';

        var nonce =
          'gs10-' +
          Date.now() + '-' +
          Math.random().toString(36).slice(2);

        var data = new URLSearchParams();

        ['full_name', 'email', 'state', 'website'].forEach(
          function (key) {
            data.append(
              key,
              form.elements[key].value.trim()
            );
          }
        );

        data.append('phone', phone);
        data.append('nonce', nonce);

        try {
          /*
            no-cors POST does not expose server success.
            Confirmation must come from Google Apps Script doGet.
          */
          var postPromise = fetch(endpoint, {
            method: 'POST',
            mode: 'no-cors',
            body: data,
            credentials: 'omit'
          });

          // Start confirmation polling without waiting
          // for the opaque POST response to finish.
          var confirmationPromise = (async function () {
            await wait(700);
            return confirmSaved(endpoint, nonce);
          })();

          var results = await Promise.allSettled([
            postPromise,
            confirmationPromise
          ]);

          var saved =
            results[1].status === 'fulfilled' &&
            results[1].value === true;

          if (!saved) {
            throw new Error(
              'Could not confirm Google Sheet entry'
            );
          }

          status.textContent =
            'Submitted successfully. Redirecting…';

          window.location.assign(THANK_YOU_URL);

        } catch (error) {
          status.textContent =
            'We could not confirm your submission. ' +
            'Please contact our team before trying again.';

          submit.disabled = false;
          submitting = false;

          console.error(
            'Gond Siyah form submission:',
            error
          );
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();




